import axios from "axios";

export const sendNotifications = async (token, message) => {
  console.log("send notification is called!");
  var data = JSON.stringify({
    data: {},
    notification: {
      title: message.title,
      body: message.body,
    },
    // token
    to: `${token}`,
  });

  var config = {
    method: "post",
    url: "https://fcm.googleapis.com/fcm/send",
    headers: {
      Authorization:
        process.env.REACT_APP_FCM_AUTHORIZATION || "",
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
    })
    .catch((error) => {
      console.log(error);
    });
};
